export default __webpack_public_path__ + "static/media/DiningFeed.4006358c.jpeg";